import serviceAuth from '../service/api/v1/auth'
import axios from 'axios';
import moment from 'moment';
import numeral from 'numeral';
import config from '@/__config'
import * as Case from "change-case";
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(isBetween);

export default (app) => {
  app.prototype.$auth = serviceAuth;
  axios.defaults.baseURL = window.API_BASE_URL && window.API_BASE_URL.data !== undefined && window.API_BASE_URL.data !== '' ? window.API_BASE_URL.data : process.env.VUE_APP_API_BASE_URL;
  app.prototype.$axios = axios;
  app.prototype.$moment = moment;
  app.prototype.$numeral = numeral;
  app.prototype.$config = config;
  app.prototype.$case = Case;
  app.prototype.$dayjs = dayjs;
}